var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var MarkerOn = function MarkerOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 47",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "MarkerOn_a",
    d: "M495 1830c-3.314 0-6 1.119-6 2.5s2.686 2.5 6 2.5 6-1.119 6-2.5-2.686-2.5-6-2.5z"
  }), React.createElement("path", {
    id: "MarkerOn_b",
    d: "M495 1788c-8.293 0-15 6.886-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.514-6.707-15.4-15-15.4"
  }), React.createElement("path", {
    id: "MarkerOn_c",
    d: "M487.306 1802.588h11.022v1.835c0 .083.03.155.09.216.061.06.133.09.216.09a.297.297 0 0 0 .22-.086l3.058-3.058a.299.299 0 0 0 .086-.22.297.297 0 0 0-.086-.22l-3.049-3.05a.359.359 0 0 0-.23-.095.297.297 0 0 0-.22.086.298.298 0 0 0-.085.22v1.835h-11.022a.294.294 0 0 0-.215.091.294.294 0 0 0-.091.215v1.835c0 .083.03.155.09.215.061.06.133.091.216.091"
  }), React.createElement("path", {
    id: "MarkerOn_d",
    d: "M501.692 1806.261H490.67v-1.835a.294.294 0 0 0-.09-.215.294.294 0 0 0-.215-.091.298.298 0 0 0-.22.086l-3.06 3.059a.3.3 0 0 0-.085.22c0 .082.029.153.086.21l3.05 3.059a.359.359 0 0 0 .229.095c.083 0 .154-.03.215-.09a.295.295 0 0 0 .09-.216v-1.835h11.022c.083 0 .155-.03.216-.09a.298.298 0 0 0 .09-.216v-1.835a.294.294 0 0 0-.09-.215.295.295 0 0 0-.216-.09"
  })), React.createElement("use", {
    fill: "#6f7070",
    xlinkHref: "#MarkerOn_a",
    opacity: 0.4,
    transform: "translate(-480 -1788)"
  }), React.createElement("use", {
    fill: "#2fa0a0",
    xlinkHref: "#MarkerOn_b",
    transform: "translate(-480 -1788)"
  }), React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#MarkerOn_c",
    transform: "translate(-480 -1788)"
  }), React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#MarkerOn_d",
    transform: "translate(-480 -1788)"
  }));
};

export default MarkerOn;